import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-126" data-mp="nu9lhg8s0g28">
      {visible && <motion.div initial={{
      y: '-100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '-100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 top-0 z-50 border-b border-gold/40 bg-forest-deep/95 backdrop-blur-md" data-id="element-127" data-mp="juhl3qtjdg7y">
          <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-3 py-2 sm:px-6" data-id="element-128" data-mp="299p44cmbu04p">
            <div className="hidden items-center gap-2 text-cream md:flex" data-id="element-129" data-mp="24acjzzmub75t">
              <ShieldIcon className="h-5 w-5 text-gold-light" strokeWidth={1.75} aria-hidden="true" data-id="element-130" data-mp="3if0bse52scmu" />
              <span className="font-serif text-lg" data-id="element-131" data-mp="3mglvaic47p60">El Escudo de Mamá</span>
              <span className="ml-2 text-sm text-cream/70" data-id="element-132" data-mp="3mhwx4cm02muh">· Oferta de lanzamiento</span>
            </div>
            <span className="btn-shine block w-full select-none whitespace-nowrap rounded-full bg-gold px-4 py-2.5 text-center text-[13px] font-extrabold uppercase tracking-wide text-forest-deep md:w-auto md:px-6 md:text-sm" data-id="element-133" data-mp="38ixdjjdcgy56">
              Aprovecha precio de lanzamiento $17 USD
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}